// import React, { useEffect, useState } from 'react';
// import { BiCheckCircle } from 'react-icons/bi';
// import { useNavigate, useParams } from 'react-router-dom';
// import { apiDELETE, apiGET, apiPUT } from '../utilities/apiHelpers';
// import { API_URL } from '../config';
// import { toast } from 'react-toastify';
// import { setCartCount } from '../redux/users/users';
// import { useDispatch, useSelector } from 'react-redux';


// const CodSuccessPage = () => {
//   const param = useParams()
//   const [orderData, setOrderData] = useState('')
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate()
//   const dispatch = useDispatch()
//   const userId = useSelector((state) => state.user.userData.id) || ''
//   const getOrderData = async () => {
//     try {
//       const response = await apiGET(`${API_URL}/v1/order/${param?.id}`)
//       if (response?.data?.status) {
//         setOrderData(response.data.data[0])

//         if (response.data.data[0].mode !== 'enquiry') {
//           deleteUserStepperProgress()
//         }

//         const updateCodOrderPayload = {
//           mode: "order"
//         }
//         const updateCodOrderResponse = await apiPUT(`/v1/order/update/${param?.id}`, updateCodOrderPayload);
//         if (updateCodOrderResponse?.data?.status) {
//           console.log("Order placed successfully")
//         } else {
//           console.log("Failed to place order")
//         }
//       } else {
//         console.error("Something went wrong")
//       }
//     } catch (error) {
//       console.log(error)
//     }
//   }

//   const deleteUserStepperProgress = async () => {
//     try {
//       setLoading(true);
//       const payload = {
//         selectedAddress: null,
//         selectedPrescription: null,
//         cartData: [],
//         currentStep: 0
//       }
//       const response = await apiPUT(`/v1/stepper-progress/update-stepper-progress/${userId}`, payload);
//       if (response.status) {
//         try {
//           const response = await apiDELETE(`/v1/cart/remove-user-cart`);
//           if (response.status) {
//             console.log(response.data.data);
//             dispatch(setCartCount(0))
//           } else {
//             console.log(response.data);
//           }
//         } catch (error) {
//           toast.error('Error Removing Cart')
//         }
//         console.log("Delete response", response.data.data);
//       }
//     } catch (error) {
//       console.error('Error fetching delete response info: ', error);
//     } finally {
//       setLoading(false);
//     }
//   }

//   useEffect(() => {
//     getOrderData()
//   }, [])

//   return (
//     <div className="flex items-center justify-center mt-10 ">
//       <div className="bg-white p-6 rounded-lg shadow-lg text-center">
//         <BiCheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
//         <h1 className="text-2xl font-bold mb-2">Order Placed Successfully!</h1>
//         <p className="text-gray-700 mb-4">Thank you for your order. Your order details are below:</p>
//         <div className="text-left">
//           <p><span className="font-semibold">Order ID:</span> {param?.id ? param?.id : "--"}</p>
//           <p className='capitalize'><span className="font-semibold ">Customer Name:</span> {orderData ? orderData.userDetails?.name : "--"}</p>
//           <p><span className="font-semibold">Total Amount:</span> ${orderData ? orderData?.totalPayment : "--"}</p>
//         </div>
//         <button className='bg-[#14967F] text-white font-semibold border w-full p-2 rounded-md my-4 transition duration-500 transform hover:scale-105 ' onClick={() => navigate("/orders")} >Go to orders</button>
//       </div>
//     </div>
//   );
// };

// export default CodSuccessPage;

import React, { useEffect, useState, useCallback, useRef } from 'react';
import { BiArrowBack } from 'react-icons/bi';
import { useNavigate, useParams } from 'react-router-dom';
import { apiDELETE, apiGET, apiPUT } from '../utilities/apiHelpers';
import { API_URL } from '../config';
import { toast } from 'react-toastify';
import { setCartCount } from '../redux/users/users';
import { useDispatch, useSelector } from 'react-redux';

const CodSuccessPage = () => {
  const { id: orderId } = useParams();
  const [orderData, setOrderData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  // Use a ref to prevent duplicate cleanup calls during strict mode or re-renders
  const cleanupPerformed = useRef(false);
  const userId = useSelector((state) => state.user?.userData?.id) || '';

  const clearUserSession = useCallback(async () => {
    if (cleanupPerformed.current) return;
    cleanupPerformed.current = true;

    try {
      const payload = {
        selectedAddress: null,
        selectedPrescription: null,
        cartData: [],
        currentStep: 0,
      };
      
      // Update Stepper
      await apiPUT(`/v1/stepper-progress/update-stepper-progress/${userId}`, payload);
      
      // Remove Cart
      const deleteCartResponse = await apiDELETE(`/v1/cart/remove-user-cart`);
      if (deleteCartResponse.status) {
        dispatch(setCartCount(0));
      }
    } catch (error) {
      console.error('Error during session cleanup:', error);
    }
  }, [userId, dispatch]);

  const fetchAndProcessOrder = useCallback(async () => {
    try {
      setLoading(true);
      const response = await apiGET(`${API_URL}/v1/order/${orderId}`);
      
      if (response?.data?.status) {
        const order = response.data.data[0];
        setOrderData(order);

        // If it's a valid order, finalize the status and clear the cart
        if (order.mode !== 'enquiry'  && order.enquiryStatus !== "fulfilled") {
          await clearUserSession();
          // Mark order as officially placed/confirmed
          await apiPUT(`${API_URL}/v1/order/update/${orderId}`, { mode: 'order' });
        }
      } else {
        toast.error("Order details not found.");
      }
    } catch (error) {
      console.error("Error fetching order data", error);
      toast.error("Failed to verify order.");
    } finally {
      setLoading(false);
    }
  }, [orderId, clearUserSession]);

  useEffect(() => {
    if (orderId) {
      fetchAndProcessOrder();
    }
  }, [orderId, fetchAndProcessOrder]);

  if (loading) {
    return <div className="flex justify-center p-10">Verifying your order...</div>;
  }

  return (
    <div className="flex justify-center items-center p-4 font-poppins mb-5">
  {loading ? (
    <div className="flex flex-col items-center">
      <div className="animate-spin w-12 h-12 border-4 border-green-600 rounded-full border-t-transparent mb-2" />
      <p className="text-gray-500">Verifying your order...</p>
    </div>
  ) : (
    <div className="rounded-lg p-6 bg-gray-200 w-full max-w-4xl">
      <div className="md:flex md:space-x-6">
        
        {/* ── Left: Confirmation ── */}
        <div className="md:w-1/2 bg-white p-8 rounded-lg shadow flex flex-col items-center text-center">
          <div className="flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4">
            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <h2 className="text-2xl font-semibold mb-4">
            Order Placed Successfully!
          </h2>
          <p className="text-gray-600 mb-6">
            Thank you for your purchase. Your Cash on Delivery order has been confirmed and is being processed.
          </p>
          <div className="flex gap-3 flex-wrap justify-center">
            <button
              onClick={() => navigate("/")}
              className="flex items-center bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 transition"
            >
              <BiArrowBack className="mr-2" /> Home
            </button>
            <button
              onClick={() => navigate("/orders")}
              className="flex items-center border border-green-600 text-green-600 py-2 px-4 rounded-lg hover:bg-green-50 transition"
            >
              My Orders
            </button>
          </div>
        </div>

        {/* ── Right: Order Details ── */}
        <div className="md:w-1/2 mt-6 md:mt-0 bg-white p-6 rounded-lg shadow">
          <h2 className="text-2xl font-semibold text-center mb-1">
            {/* Replace with your actual total amount variable */}
            ₹{orderData?.totalPayment || "0.00"}
          </h2>
          <p className="text-green-600 text-center mb-6 font-medium">✓ COD Confirmed</p>

          <div className="space-y-3 text-sm">
            <div className="flex justify-between border-b pb-2">
              <span className="text-gray-500">Order ID</span>
              <span className="font-mono text-xs font-bold text-gray-800">#{orderId}</span>
            </div>

            <div className="flex justify-between border-b pb-2">
              <span className="text-gray-500">Customer</span>
              <span className="font-medium capitalize">{orderData?.userDetails?.name || "--"}</span>
            </div>

            <div className="flex justify-between border-b pb-2">
              <span className="text-gray-500">Method</span>
              <span className="font-medium">Cash on Delivery</span>
            </div>

            {orderData?.createdAt && (
              <div className="flex justify-between border-b pb-2">
                <span className="text-gray-500">Date</span>
                <span className="font-medium">
                  {new Date(orderData.createdAt).toLocaleDateString()}
                </span>
              </div>
            )}

            <div className="flex justify-between pb-2">
              <span className="text-gray-500">Status</span>
              <span className="font-medium text-green-600 uppercase tracking-wider text-xs">Pending Dispatch</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  )}
</div>
  );
};

export default CodSuccessPage;